<template>
  <div>
    <div align="center" style="margin:auto;padding:50px 0;">
      <!--
      <h1>Privacy and Compliance</h1>
      <br />
      -->
      <div>
        <iframe
          id="EULA"
          :src="Lahtml"
          title="EULA"
          style="width:40%;height:400px;border:none;font-family:'Calibri';"
        ></iframe>
        <div class="form-group" style="width:40%;">
          <br />
          <input
            v-model="eulaChecked"
            type="checkbox"
            style="width:20px;height:20px;vertical-align:sub;"
          /><strong> Agree</strong><br />
        </div>
        <br />
        <div style="width:40%;text-align:left;">
          <hr />
          <br />
          <h5>
            <input
              v-model="privacy1Checked"
              type="checkbox"
              style="width:20px;height:20px;vertical-align:text-bottom;"
            />
            I confirm that I have read the data processing
            <a :href="LinkInformativa_EN" download>information statement </a>, under of Regulation
            (UE) 679/2016
            <br />
            <br />
            Confermo di aver preso visione dell'<a :href="LinkInformativa_IT" download
              >informativa sul trattamento dei dati</a
            >, ai sensi dell'art. 13 del Reg. UE 679/2016.
          </h5>
          <br />
        </div>
        <div v-show="show2Check" style="width:40%;text-align:left;">
          <hr />
          <br />
          <h5>
            <input
              v-model="privacy2Checked"
              type="checkbox"
              style="width:20px;height:20px;vertical-align:text-bottom;"
            />
            I consent to data processing for activities of direct marketing, as per the personal
            data processing information statement, point 2 d)
            <br />
            <br />
            Acconsento al trattamento dati per finalità d), attività di marketing diretto
            dell'informativa per il trattamento dei dati personali.
          </h5>
          <br />
        </div>
        <br />
        <div style="width:40%;">
          <b-row>
            <b-col>
              <button class="btn btn-lg btn-success btn-block" @click="onClickLogout()">
                LOGOUT
              </button>
            </b-col>
            <!--
            <b-col v-if="!allChecked">
              <button class="btn btn-lg btn-success btn-block" @click="saveInfo()">
                SAVE
              </button>
            </b-col>
            -->
            <b-col>
              <button
                :disabled="!allChecked"
                class="btn btn-lg btn-success btn-block"
                @click="saveInfoNext()"
              >
                SAVE &amp; CONTINUE
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generalService from "@/services/backendCipriani/generalService.js";
import Cookies from "js-cookie";

export default {
  name: "CompliancePrivacy",
  data() {
    return {
      eulaChecked: false,
      privacy1Checked: false,
      privacy2Checked: false,
      show2Check: true,
      compliance: null,
      idLogo: 1,
      Lahtml: "compliance\\1\\La.html",
      LinkInformativa_IT: "compliance\\1\\INFORMATIVA_PRIVACY_IT.pdf",
      LinkInformativa_EN: "compliance\\1\\INFORMATIVA_PRIVACY_EN.pdf"
    };
  },
  computed: {
    allChecked: function() {
      if (this.show2Check) {
        return this.eulaChecked && this.privacy1Checked /*&& this.privacy2Checked */;
      } else {
        return this.eulaChecked && this.privacy1Checked;
      }
    }
  },
  mounted: function() {
    var that = this;

    document.getElementById("mainOverlay").setAttribute("style", "display: none;");

    document.getElementById("mainRouterView").setAttribute("style", "");

    generalService.getLogoVisibility().then(function(data) {
      that.show2Check = data;
    });

    generalService.getCheckedCompliances().then(function(data) {
      that.idLogo = data.idLogo;
      that.Lahtml = "compliance\\{L}\\La.html".replace("{L}", that.idLogo);
      that.LinkInformativa_IT = "compliance\\{L}\\INFORMATIVA_PRIVACY_IT.pdf".replace(
        "{L}",
        that.idLogo
      );
      that.LinkInformativa_EN = "compliance\\{L}\\INFORMATIVA_PRIVACY_EN.pdf".replace(
        "{L}",
        that.idLogo
      );

      that.eulaChecked = data.compliance_1;
      that.privacy1Checked = data.compliance_2;
      that.privacy2Checked = data.compliance_3;
      that.compliance = data;
    });

    /*
    var frame = document.getElementById("EULA");
    frame.onload = function() {
      let body = frame.contentWindow.document.querySelector("body");
      body.style.fontFamily = "Segoe UI";
    };
    */
  },
  methods: {
    saveInfoNext() {
      this.setInfo();
      var that = this;
      generalService.setCheckedCompliances(this.compliance).then(function() {
        that.$router.push("/dashboard");
      });
    },
    saveInfo() {
      this.setInfo();
      generalService.setCheckedCompliances(this.compliance);
    },
    setInfo() {
      this.compliance.compliance_1 = this.eulaChecked;
      this.compliance.data_1 = new Date();
      this.compliance.compliance_2 = this.privacy1Checked;
      this.compliance.data_2 = new Date();
      this.compliance.compliance_3 = this.privacy2Checked;
      this.compliance.data_3 = new Date();
    },
    onClickLogout() {
      this.setInfo();
      var that = this;
      generalService.setCheckedCompliances(this.compliance).then(function() {
        Cookies.remove("loginToken");
        // reload page
        that.$router.go();
      });
    }
  }
};
</script>
